module.exports = __webpack_public_path__ + "static/media/vnda10.658b2955.png";